<app-patient-general-info [IsView]="true"></app-patient-general-info>
